import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;    // "vendor" or "purchaser"
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  vendor_from?: string;
  vendor_to?: string;
  product_from?: string;
  product_to?: string;
  dept_from?: string;
  dept_to?: string;
  purchaser_from?: string;
  purchaser_to?: string;
}

export interface ReportRow {
  FD110_12: string;      // vendor code
  vendor_name: string;
  FD110_01: string;      // order no
  FD110_11: string;      // order date
  FD111_10: string;      // product code 1
  FD111_11: string;      // product code 2
  product_code: string;  // concatenated
  FD111_16: string;      // unit
  FD111_15: number;      // qty
  amount: number;
  FD110_31: string;      // purchaser code
  purchaser_name: string;
  FD110_32: string;      // dept code
  dept_name: string;
}

export interface VendorCount {
  code: string;
  name: string;
  count: number;
}

export interface UnitSummary {
  FD111_16: string;   // unit
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  group_counts: VendorCount[];
  unit_summary: UnitSummary[];
  message?: string;
}

export const d301Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d301/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d301/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
